module.exports = __webpack_public_path__ + "img/botaopatodeminassetcemg.88367281.png";